import { Routes } from '@angular/router';
import { ROUTES } from './shared/constants/routes.constants';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: ROUTES.HOME,
    pathMatch: 'full',
  },
  {
    path: ROUTES.HOME,
    title: 'Home',
    loadComponent: () =>
      import('./features/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: ROUTES.RICERCA,
    data: { titoloDinamico: true },
    loadComponent: () =>
      import('./features/ricerca/ricerca.component').then(
        (m) => m.RicercaComponent,
      ),
  },
  {
    path: ROUTES.PROGETTO,
    title: 'Il Progetto',
    data: { tab: 'progetto' },
    loadComponent: () =>
      import('./features/progetto/progetto.component').then(
        (m) => m.ProgettoComponent,
      ),
  },
  {
    path: ROUTES.PROGETTO_FASCICOLO,
    title: 'Il Fascicolo',
    data: { tab: 'fascicolo' },
    loadComponent: () =>
      import('./features/progetto/progetto.component').then(
        (m) => m.ProgettoComponent,
      ),
  },
  {
    path: ROUTES.PROGETTO_LINEE_GUIDA,
    title: 'Linee guida',
    data: { tab: 'linee-guida' },
    loadComponent: () =>
      import('./features/progetto/progetto.component').then(
        (m) => m.ProgettoComponent,
      ),
  },
  {
    path: ROUTES.DETTAGLIO + '/:id',
    data: { titoloDinamico: true },
    loadComponent: () =>
      import('./features/dettaglio/dettaglio.component').then(
        (m) => m.DettaglioComponent,
      ),
  },
  {
    path: ROUTES.FASCICOLO,
    title: 'Il mio fascicolo',
    loadComponent: () =>
      import('./features/fascicolo/fascicolo.component').then(
        (m) => m.FascicoloComponent,
      ),
  },
  {
    path: ROUTES.FASCICOLO_VIEWER,
    title: 'Visualizza fascicolo',
    loadComponent: () =>
      import('./features/fascicolo/fascicolo-viewer/fascicolo-viewer.component').then(
        (m) => m.FascicoloViewerComponent,
      ),
  },
  {
    path: ROUTES.PREFERITI,
    title: 'I miei preferiti',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/preferiti/preferiti.component').then(
        (m) => m.PreferitiComponent,
      ),
  },
  {
    path: `${ROUTES.VISUALIZZAZIONE_EDIZIONE}/:id`,
    data: { titoloDinamico: true },
    loadComponent: () =>
      import('./features/visualizzatore-pdf/visualizzatore-edizione/visualizzatore-edizione.component').then(
        (m) => m.VisualizzatoreEdizioneComponent,
      ),
  },
  {
    path: `${ROUTES.VISUALIZZAZIONE_SINGOLA_PAGINA}/:id`,
    data: { titoloDinamico: true },
    loadComponent: () =>
      import('./features/visualizzatore-pdf/visualizzatore-singola-pagina/visualizzatore-singola-pagina.component').then(
        (m) => m.VisualizzatoreSingolaPaginaComponent,
      ),
  },
  {
    path: ROUTES.COOKIE_POLICY,
    title: 'Cookie Policy',
    loadComponent: () =>
      import('./features/cookie-policy/cookie-policy.component').then(
        (m) => m.CookiePolicyComponent,
      ),
  },
  {
    path: '**',
    redirectTo: ROUTES.HOME,
    pathMatch: 'full',
  },
];
